angular.module('zc.master')

.directive 'zcSegmentEstimatedVisitors', ($state, $q, $translate, Meta, CampaignSegment, MasterMongoSession, MasterMongoVisitor, MasterAccessStats, SegmentEstimator, SegmentMatcher, lib) ->
  restrict: 'E'
  templateUrl: "/templates/master.segments/segment_estimated_visitors.html"
  replace: true
  scope:
    segment: "="
    project: "="
    timingSegment: "="  # If this is set, estimation also uses timing segment to filter original sessions/stats.
    sessionOnly: "@"  # If true is passed in, it doesn't aggregate / show results from accessStat
    timeDeltaHour: "@"  # If specified, aggregate sessions specified hours before.
  link: (scope, element, attrs) ->

  controller: ($scope) ->
    $scope.sessions = []
    $scope.deviceSessions = []
    $scope.matchedSessions = 0
    $scope.totalSessionCount = 0
    $scope.matchedSessionCount = 0
    $scope.matchedPercentage = 0
    $scope.accessStatsMatchedCounts = { all: 0 }
    $scope.accessStatsTotalCounts = { all: 0 }
    $scope.accessStatsStart = undefined
    $scope.accessStatsEnd = undefined
    $scope.mode = "sessions"
    $scope.devices = [
      { name: $translate.instant('masterSegments.segmentEstimatedVisitors.all'), value: "all" }
      { name: $translate.instant('masterSegments.segmentEstimatedVisitors.pc'), value: "pc" }
      { name: $translate.instant('masterSegments.segmentEstimatedVisitors.sp'), value: "sp" }
      { name: $translate.instant('masterSegments.segmentEstimatedVisitors.tablet'), value: "tablet" }
    ]
    if $scope.project.enable_app
      $scope.devices.push { name: $translate.instant('masterSegments.segmentEstimatedVisitors.app'), value: "app" }
    $scope.filters = { device: $scope.devices[0] }

    $scope.getAccessStats = () ->
      return [] if !$scope.segment or $scope.sessionOnly
      SegmentEstimator.getAccessStats($scope.project.apikey,
        moment().subtract(1, "days").startOf("day").toDate(),
        $scope.segment.id)
      .then (accessStats) ->
        for key, val of accessStats
          $scope[key] = val

    $scope.getSessions = () ->
      timeLimitDate = null
      if $scope.timeDeltaHour
        timeLimitDate = moment().subtract($scope.timeDeltaHour, 'hours').toDate()
      SegmentEstimator.getSessions($scope.project.apikey, timeLimitDate)
      .then (sessions) ->
        $scope.sessions = sessions
        $scope.handleSessions()

    $scope.handleSessions = () ->
      return if !$scope.segment?.mongo_query or $scope.sessions.length <= 0
      filteredSessions = SegmentEstimator.filterSessionsBySegmentQuery $scope.segment.mongo_query,
        $scope.filters.device.value,
        $scope.sessions,
        $scope.timingSegment

      for key, val of filteredSessions
        # Assign $scope.deviceSessions / $scope.matchedSessions
        $scope[key] = val
      $scope.calculatePercentage()

    $scope.calculatePercentage = () ->
      if $scope.mode == 'sessions'

        $scope.totalSessionCount = $scope.deviceSessions.length
        $scope.matchedSessionCount = $scope.matchedSessions.length

      else if $scope.mode == 'access_stats'

        $scope.totalSessionCount = $scope.accessStatsTotalCounts[$scope.filters.device.value]
        $scope.matchedSessionCount = $scope.accessStatsMatchedCounts[$scope.filters.device.value]

      if $scope.totalSessionsCount == 0
        $scope.matchedPercentage = 0
      else
        $scope.matchedPercentage = $scope.matchedSessionCount / $scope.totalSessionCount * 100

    $scope.switchMode = (mode) ->
      $scope.mode = mode
      $scope.calculatePercentage()

    $scope.getSessions()


    $scope.accessStatsExist = ->
      !!$scope.accessStatsMatchedCounts.all

    $scope.isRecentlyUpdated = (segment) ->
      return true if !segment.updated_at && !segment.created_at

      date = segment.created_at
      if segment.updated_at
        date = segment.updated_at

      # should have at least 1 whole day before we have trustable data
      moment(date).valueOf() > moment().startOf("day").subtract(1, "days").valueOf()

    $scope.$watch 'filters.device', (newval) ->
      $scope.handleSessions()

    $scope.$watch 'segment', (newval) ->
      # Watch the segment (it may be undefined at first).
      if newval && !$scope.accessStatsExist()
        $scope.getAccessStats()

    $scope.$watch 'segment.mongo_query', (newval) ->
      # Check for message first. This is from campaign segment editor
      # used for "custom" segment. If there is message (error), set percentages
      # to 0
      if $scope.segment?.message
        $scope.matchedPercentage = 0
        $scope.matchedSessionCount = 0
      else if newval
        $scope.handleSessions()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.segments/segment_estimated_visitors.directive.coffee